import { render, staticRenderFns } from "./DetalhamentoValoresProcessados.vue?vue&type=template&id=6153fd36&scoped=true"
import script from "./DetalhamentoValoresProcessados.vue?vue&type=script&lang=js"
export * from "./DetalhamentoValoresProcessados.vue?vue&type=script&lang=js"
import style0 from "./DetalhamentoValoresProcessados.vue?vue&type=style&index=0&id=6153fd36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6153fd36",
  null
  
)

export default component.exports